import React from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Container, Row } from 'react-bootstrap';
import "../trending_roducts/TrendingRoducts.css"
import ReusableTrendingProducts from '../organic9-reusable/ReusableTrendingRoducts';

function TrendingProducts() {
  return (
    <section id="trending_products">
      <Container>
        <h1>Trending Products</h1>
        <Tabs defaultActiveKey="featured" id="justify-tab-example" className="mb-3" justify>
          <Tab eventKey="featured" title="Featured">
            <Row style={{rowGap: '20px'}}>
              <ReusableTrendingProducts img="imeges/desktop 9/strawberry.svg" />
              <ReusableTrendingProducts img="imeges/desktop 9/resbarry small.svg" />
              <ReusableTrendingProducts img="imeges/desktop 9/orange.svg" />
              <ReusableTrendingProducts img="imeges/desktop 9/blackberry.svg" />
              <ReusableTrendingProducts img="imeges/desktop 9/cherry.svg" />
              <ReusableTrendingProducts img="imeges/desktop 9/tomato.svg" />
            </Row>
          </Tab>
          <Tab eventKey="latest" title="Latest">
            <Row style={{rowGap: '20px'}}>
              <ReusableTrendingProducts img="imeges/desktop 9/strawberry.svg" />
              <ReusableTrendingProducts img="imeges/desktop 9/resbarry small.svg" />
              <ReusableTrendingProducts img="imeges/desktop 9/orange.svg" />
              <ReusableTrendingProducts img="imeges/desktop 9/blackberry.svg" />
              <ReusableTrendingProducts img="imeges/desktop 9/cherry.svg" />
              <ReusableTrendingProducts img="imeges/desktop 9/tomato.svg" />
            </Row>
          </Tab>
          <Tab eventKey="best-seller" title="Best Seller">
            <Row style={{rowGap: '20px'}}> 
              <ReusableTrendingProducts img="imeges/desktop 9/strawberry.svg" />
              <ReusableTrendingProducts img="imeges/desktop 9/resbarry small.svg" />
              <ReusableTrendingProducts img="imeges/desktop 9/orange.svg" />
              <ReusableTrendingProducts img="imeges/desktop 9/blackberry.svg" />
              <ReusableTrendingProducts img="imeges/desktop 9/cherry.svg" />
              <ReusableTrendingProducts img="imeges/desktop 9/tomato.svg" />
            </Row>
          </Tab>
        </Tabs>
      </Container>
    </section>
  );
}

export default TrendingProducts;
